import { Component, OnInit } from '@angular/core';
import Action from 'src/app/models/action';
import { ModalController, NavController, AlertController } from '@ionic/angular';
import { ActionService } from 'src/app/services/action.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/services/global.service'

@Component({
  selector: 'app-select-actions',
  templateUrl: './select-actions.page.html',
  styleUrls: ['./select-actions.page.scss'],
})
export class SelectActionsPage implements OnInit  {
  public actions: Action[] = [];
  public selectedActions: Action[];
  public isLoadingActions: Boolean;
  public fetchNewActions: boolean = true;
  public visibleActions;
  public maximum: number = undefined;
  public sequencesOnly: boolean = false;
  public openActions: Action[] = [];
  public archivedActions: Action[] = [];
  public sequenceActions: Action[] = [];
  public visibleOpenActions: Action[] = [];
  public visibleArchivedActions: Action[] = [];
  public visibleSequenceActions: Action[] = [];
  public hasMoreActions: boolean = false;
  public isIosDevice: boolean = false;
  public skeletonRows: number[] = [1,2,3,4,5];
  private allSelectableActions: Action[] = [];
  private selectedActionIds: Set<number> = new Set();
  private actionRenderLimit: number = 60;
  private actionRenderStep: number = 60;

  constructor(
    private modalController: ModalController,
    private navController: NavController,
    private actionService: ActionService,
    private alertController: AlertController,
    private translateService: TranslateService,
    private globalService: GlobalService
  ) {}

  public async ngOnInit () {
    GlobalService.log("Selected Actions:");
    GlobalService.log(this.selectedActions);
    if(this.selectedActions == undefined){
      this.selectedActions = [];
    }
    this.isIosDevice = this.globalService.isIos();
    this.updateSelectedActionIds();
    await this.ionViewDidEnterManual();
  }

  public ionViewDidEnterManual () {
    if (this.fetchNewActions) {
      this.getActions();
    } else { 
      this.fetchNewActions = true; // Ensure fetchNewContacts is on for future contact selects
    }
  }

  public searchActions(eventData){
    const sourceActions = ActionService.SearchedActions || this.allSelectableActions;
    if(eventData.detail.value){
      let searchValue = eventData.detail.value.toLowerCase();
      GlobalService.log(searchValue);
      GlobalService.log(ActionService.SearchedActions);

      this.actions = sourceActions.filter(action => action.title && action.title.toLowerCase().includes(searchValue));
      this.resetActionRenderLimit();
      this.updateActionViews();
      GlobalService.log(this.actions);
    } else {
      this.actions = [...sourceActions];
      this.resetActionRenderLimit();
      this.updateActionViews();
    }
  }

  public searchedActions(){
    return ActionService.SearchedActions;
  }

  public async getActions () {
    this.isLoadingActions = true;

    let actions = await this.actionService.getActionsByStatus(-1)
    GlobalService.log(actions);
    this.actions = [];
    for(let action of actions){
      if(this.sequencesOnly) {
        GlobalService.log("sequencesOnly");
        if(!action.id_previous_action && action.type != "Personal"){ this.actions.push(action); }
      }
      else if(!action.status || action.status == 0 || action.status == 1) { this.actions.push(action); }
    };

    this.allSelectableActions = [...this.actions];
    ActionService.SetSearchedActions(this.allSelectableActions);
    this.updateActionViews();
    GlobalService.log("Current Actions", this.actions);
    this.isLoadingActions = false;
  }

  public dismiss(dismissed) {
    GlobalService.log(this.selectedActions);
    GlobalService.log(dismissed);
    
    this.modalController.dismiss({
      dismissed: dismissed,
      actions: this.selectedActions
    });
  }

  public goBack() {
    this.dismiss(false);
  }

  public submit() {
    this.dismiss(true);
  }

  private compareActions (action: Action) {
    return x => (action.id_action != undefined && x.id_action == action.id_action);
  }

  public actionIsSelected (action: Action): boolean {
    if(action.id_action == undefined) return this.selectedActions.find(this.compareActions(action)) != undefined;
    return this.selectedActionIds.has(action.id_action);
  }

  public selectAction (action: Action) {
    if (this.actionIsSelected(action)) {
      this.selectedActions.splice(this.selectedActions.findIndex(this.compareActions(action)),1);
    } else {
      if(this.maximum == 1){
        this.selectedActions = [];
      }
      this.selectedActions.push(action);
    }
    this.updateSelectedActionIds();
  }

  public loadMoreActions($event = undefined) {
    this.actionRenderLimit += this.actionRenderStep;
    this.updateActionViews();
    if($event) $event.target.complete();
  }

  public selectAll () {
    let activeActions = this.sequencesOnly ? this.sequenceActions : this.openActions;
    if (this.selectedActions.length == activeActions.length) {
      this.selectedActions = [];
    } else {
      this.selectedActions = [];
      this.selectedActions = [...activeActions];
    }
    this.updateSelectedActionIds();
  }
  
  isIos(){
    return this.globalService.isIos();
  }

  public trackByAction(index: number, action: Action) {
    return action?.id_action || index;
  }

  public trackByIndex(index: number) {
    return index;
  }

  private updateActionViews() {
    this.sequenceActions = this.actions;
    this.openActions = this.actions.filter(action => action.status == 0);
    this.archivedActions = this.actions.filter(action => action.status != 0);
    this.visibleSequenceActions = this.sequenceActions.slice(0, this.actionRenderLimit);
    this.visibleOpenActions = this.openActions.slice(0, this.actionRenderLimit);
    this.visibleArchivedActions = this.archivedActions.slice(0, this.actionRenderLimit);
    this.hasMoreActions = this.sequencesOnly
      ? this.visibleSequenceActions.length < this.sequenceActions.length
      : this.visibleOpenActions.length < this.openActions.length || this.visibleArchivedActions.length < this.archivedActions.length;
  }

  private updateSelectedActionIds() {
    this.selectedActionIds = new Set((this.selectedActions || []).filter(action => action.id_action != undefined).map(action => action.id_action));
  }

  private resetActionRenderLimit() {
    this.actionRenderLimit = this.actionRenderStep;
  }
}
